import { Menu } from 'module/ui/components/atoms/dropdown/menu';
import { Layout } from 'module/ui/components/templates/argon/components';
import { Body01 } from 'module/ui/ozone/atoms/typography/body';
import styled from 'styled-components';

export const AllSignalsSidebar = styled(Layout.Sider)`
  width: 294px !important;
  min-width: 294px !important;
  max-width: 294px !important;
  height: 100%;
  background: #fff;
  padding: 16px;
  border-right: none;
  display: flex;
  flex-direction: column;
  gap: 0;
  border-right: 1px solid #f2f2f2;
`;

export const SidebarSearchWrapper = styled.div`
  margin-bottom: 16px;
`;

export const AllSignalsContentWrapper = styled(Layout.Content)`
  flex: 1 1 auto !important;
  overflow: hidden;
`;

export const AllSignalsAccountHeaderWrapper = styled.div`
  padding-left: var(--spacing-06);
  position: sticky;
  top: 0;
  width: 100%;
  z-index: var(--zindex-layer-00);
  background-color: var(--white-100);
`;

export const SignalsContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow-y: scroll;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 8px;
  font-size: 14px;
  color: #161616;
  font-weight: 590;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  height: 32px;
`;

export const Count = styled.div`
  display: flex;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  padding: 0px 4px;
  color: #8d8d8d;
  font-size: 12px;
`;

export const SectionSubItem = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  /* padding: 2px 8px 2px 32px; */
  padding: 2px 8px 2px 0px;
  font-size: 14px;
  color: #161616;
  border-radius: 4px;
  background: ${({ selected }) => (selected ? '#F4F4F4' : 'transparent')};
  cursor: pointer;
  transition: background 0.15s;
  height: 32px;
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0;
  }

  justify-content: space-between;
`;

export const SectionSubItemLabel = styled(Body01)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AllSignalsSidebarMenu = styled(Menu)`
  padding: 0;
  margin: 0;
  height: auto;
  max-height: unset;
  border-radius: 0;
  .ant-menu-sub.ant-menu-inline {
    background: transparent;
  }
  .ant-menu-submenu-title,
  .ant-menu-item {
    padding: 0 var(--spacing-03);
    margin-bottom: 4px;
  }
  .ant-menu-submenu {
    .ant-menu-submenu-title {
      padding-left: 8px !important;
    }
    .ant-menu-item {
      padding-left: 40px !important;
    }
    .ant-menu-submenu-expand-icon {
      right: var(--spacing-03);
      left: unset;
    }
  }
  .ant-menu-item {
    padding-left: 8px !important;
  }
`;

export const ExpandIcon = styled.div`
  color: var(--brand-color);
  position: absolute;
  right: var(--spacing-03);
  left: unset;
`;

export const SignalsContainer = styled.div`
  max-width: 560px;
`;
